import React from 'react';
import { whyUs } from '../data/content';

export default function WhyUs() {
  return (
    <section id="why" className="relative py-24 lg:py-36">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-4" data-reveal>
            <p className="sec-num text-sm tracking-[0.3em] uppercase">/ 04</p>
            <p className="mt-6 text-[13px] tracking-[0.24em] uppercase text-[#7a7369]">{whyUs.eyebrow}</p>
          </div>
          <div className="lg:col-span-8">
            <h2 className="font-serif text-[36px] sm:text-[44px] lg:text-[56px] leading-[1.05] tracking-[-0.015em] text-[#2E2C28] font-light" data-reveal style={{ '--reveal-delay': '120ms' }}>
              Why founders choose <span className="italic text-[#B5876C]">Founder Growth Collective</span>.
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[#d9d2ca]">
          {whyUs.pillars.map((p, i) => (
            <div
              key={p.title}
              data-reveal
              style={{ '--reveal-delay': `${i * 90}ms` }}
              className="bg-[#EBE4DE] p-8 lg:p-12 transition-colors duration-300 hover:bg-[#F1EAE1]"
            >
              <p className="sec-num text-xs tracking-[0.3em] uppercase mb-6">/ 0{i + 1}</p>
              <h3 className="font-serif text-2xl lg:text-3xl text-[#2E2C28] font-light leading-tight">{p.title}</h3>
              <p className="mt-6 text-base lg:text-lg text-[#4a463f] leading-relaxed font-light">{p.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
